import _extends from '@babel/runtime/helpers/extends';
import React__default, { useEffect } from 'react';
import styled from 'styled-components';
import { N as NativeTimeInput } from './CustomTimeInput/CustomTimeInput.styles-DwA-7eUx.js';
import { I as Input } from '../Input/Input-brOFupew.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';
import { T as TimeInput$1 } from './CustomTimeInput/CustomTimeInput-Dmf15pQi.js';
import { I as Icon } from '../Icon/Icon-Cgh13Jz2.js';
import { z as clock } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const getTimeInputSupported = () => {
  try {
    const input = document.createElement('input');
    const value = 'a';
    input.setAttribute('type', 'time');
    input.setAttribute('value', value);
    return input.value !== value;
  } catch (error) {
    return false;
  }
};

/**
 * helper function to check if time value passed is valid
 * @param time string value of 24 hour time formatted "HH:mm"
 * @returns true if the time is a valid 24 hour time or it's undefined or it's an empty string
 */
const isValidTime = time => time === undefined || time === '' || typeof time === 'string' && /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time);
const SizeWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-uvql8e-0"
})(["min-width:120px;overflow:hidden;"]);
const TimeInput = ({
  id,
  value,
  onChange = noop,
  disableNativeTimeInput = false,
  hourInputLabel = 'Hours Time Picker',
  minuteInputLabel = 'Minutes Time Picker',
  meridiemInputLabel = 'AM/PM Time Picker',
  taktId,
  ...rest
}) => {
  useEffect(() => {
    const isValidTimeValue = isValidTime(value);

    // throw a similar warning as the native input would if an invalid value was passed
    if (disableNativeTimeInput && !isValidTimeValue) {
      // eslint-disable-next-line no-console
      console.warn(`The specified value "${value}" does not conform to the required format. The format is "HH:mm" where HH is 00-23 and mm is 00-59.`);
    }
  }, [disableNativeTimeInput, value]);
  const isTimeInputSupported = getTimeInputSupported() || false;
  const useCustomInput = disableNativeTimeInput || !isTimeInputSupported;
  const inputElement = useCustomInput ? TimeInput$1 : NativeTimeInput;
  return /*#__PURE__*/React__default.createElement(SizeWrapper, null, /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, {
    id: id,
    inputElement: inputElement,
    prefix: /*#__PURE__*/React__default.createElement(Icon, {
      type: clock
    }),
    type: "time",
    value: value,
    onChange: onChange,
    taktId: taktId !== null && taktId !== void 0 ? taktId : createStormTaktId('time-input')
  }, useCustomInput && {
    hourInputLabel,
    minuteInputLabel,
    meridiemInputLabel
  })));
};

export { TimeInput as T };
//# sourceMappingURL=TimeInput-6MNhzCmm.js.map
